import React from 'react';

import loadBulkGiftCodesPage from 'bundle-loader?lazy&title=BulkGiftCodes!./components/routes/bulk-gift-codes';
import loadGiftCodesSearchPage from 'bundle-loader?lazy&title=GiftCodes!./components/routes/gift-codes-lookup';
import loadCompanyErrorPage  from 'bundle-loader?lazy&title=CompanyErrorPage!./components/routes/company-error/company-error.jsx';

const Bundle = ( Component, routeProps = {} ) => (
    ( props ) => (
        <Component { ...props } { ...routeProps } />
    )
);

export const routes = [ {
    title: 'Gift Codes',
    pattern: '/:companyId',
    load: loadGiftCodesSearchPage
}, {
    title: 'Create Gift Codes',
    pattern: '/:companyId/awards/:awardId/create-gift-codes',
    load: loadBulkGiftCodesPage
}, {
    title: 'Gift Codes',
    pattern: '/',
    load: loadCompanyErrorPage
} ];

export function bundleRoutingMiddleware( action, nextRoute, prevRoute ) {
    const { match } = nextRoute;

    if (
        match &&
        !match.render &&
        typeof match.load === 'function'
    ) {
        match.load( ( asyncModule ) => {
            match.render = Bundle(
                asyncModule.default ?
                    asyncModule.default
                    :
                    asyncModule, match.props
            );
            action.ok();
        } );
    } else {
        action.ok();
    }
}